import type { ICellRendererParams } from 'ag-grid-community';
import type { ForecastRun } from '../../schema';

function formatCount(n: number | null): string {
  return n == null ? '—' : n.toLocaleString('en-IN');
}

// Compact "in → features → forecast" triple, useful for spotting where a
// pipeline run dropped data (e.g., features=0 means feature-engineering failed).
export function RowsTriple(p: ICellRendererParams<ForecastRun>) {
  if (!p.data) return null;
  const { rowsInput, rowsFeatures, rowsForecast } = p.data;
  return (
    <span className="flex h-full items-center gap-1 text-[12.5px] tabular-nums text-foreground">
      <span>{formatCount(rowsInput)}</span>
      <span className="text-foreground-muted">→</span>
      <span>{formatCount(rowsFeatures)}</span>
      <span className="text-foreground-muted">→</span>
      <span>{formatCount(rowsForecast)}</span>
    </span>
  );
}
